// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2l8OY","modalForm":"UpgradeEpcsModal_modalForm__1GMlo","modalFooter":"UpgradeEpcsModal_modalFooter__3L_kH"};